import { Badge, Text } from "@shopify/polaris"
import { Tone } from "@shopify/polaris/build/ts/src/components/Badge/types"
import classNames from "classnames"
import React from "react"

export interface BadgeType {
  tone: Tone | undefined
  content: string
}

import styles from "./index.module.scss"

interface APPCardProps {
  id: string
  logo: string
  title: string
  description: string
  link: string
  hasHover?: boolean
  padding?: "300" | "400"
  badges: BadgeType[] | null
  onClick?: () => void
}

const APPCard: React.FC<APPCardProps> = ({
  id,
  logo,
  title,
  link,
  description,
  hasHover,
  padding = "300",
  badges = [],
  onClick,
}) => {
  return (
    <a
      target={"_blank"}
      href={link}
      className={classNames(
        styles.cardWrapper,
        hasHover ? styles.hasHover : styles.defaultHover,
      )}
      rel="noreferrer"
      style={{ padding: `var(--p-space-${padding})` }}
      onClick={onClick}
      data-cwill-report-name="recommend_app_exposure"
      // 曝光事件属性
      data-cwill-report-attr={JSON.stringify({
        position: "home_recommended_apps",
        recommend_app_id: id || "",
        recommend_app_name: title || "",
      })}
    >
      {/* <Card padding={padding}>*/}
      <div className="flex items-start gap-2">
        {/* Logo */}
        <div className={styles.logo}>
          <img src={logo} alt={title} />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Title and Badge */}
          <div className="flex flex-col gap-1">
            <Text variant="bodyMd" fontWeight={"medium"} as="h4" tone={"base"}>
              <div className={"ellipsis"}>{title}</div>
            </Text>
            <div className={"flex gap-1 flex-wrap h-[20.5px] overflow-hidden"}>
              {badges &&
                badges.map((badge) => (
                  <div key={badge.content}>
                    <Badge tone={badge.tone}>{badge.content}</Badge>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/* Description */}
      <div className="mt-2 line-clamp-2">
        <Text variant="bodyMd" as="p" tone="subdued">
          {description}
        </Text>
      </div>
      {/* </Card>*/}
    </a>
  )
}

export default APPCard
